import { GrantFinancialDto } from "../../dtos/GrantFinancialDto";
import { ApiResult, apiWrapperWithError } from "./ApiUtils";

const base = 'api/grant-financial';

export const getGrantFinancial = async (grantId: string): Promise<ApiResult<GrantFinancialDto> | null> => {
    return apiWrapperWithError<GrantFinancialDto>(`${base}/${grantId}`, 'GET', `fetching financial data for grant ${grantId}`);
}

export const saveProjectRequiredBudget = async (grantId: string, projectRequiredBudget: number | null): Promise<ApiResult<GrantFinancialDto> | null> => {
    return apiWrapperWithError<GrantFinancialDto>(`${base}/${grantId}/budget`, 'PUT', 'saving the project required budget', { projectRequiredBudget });
}

export const addFundingSource = async (grantId: string, amount: number, source: string): Promise<ApiResult<GrantFinancialDto> | null> => {
    return apiWrapperWithError<GrantFinancialDto>(`${base}/${grantId}/funding-sources`, 'POST', 'adding a funding source', { amount, source });
}

export const updateFundingSource = async (grantId: string, sourceId: string, amount: number, source: string): Promise<ApiResult<GrantFinancialDto> | null> => {
    return apiWrapperWithError<GrantFinancialDto>(`${base}/${grantId}/funding-sources/${sourceId}`, 'PUT', 'updating a funding source', { amount, source });
}

export const deleteFundingSource = async (grantId: string, sourceId: string): Promise<ApiResult<GrantFinancialDto> | null> => {
    return apiWrapperWithError<GrantFinancialDto>(`${base}/${grantId}/funding-sources/${sourceId}`, 'DELETE', 'removing a funding source');
}
